import mainTranslate from 'loankeeper-common/helpers/language'
import { Result, failure, success } from '../shared'
import { CustomFieldsProvider } from './customFields.provider'
import { CustEEItemParams } from './models'
import {
  CustomFieldsServiceErrorCode,
  CustomFieldsServerData,
  CustomFieldsGroup,
  CustomFieldsAttributes,
  CustEEItemsActions,
} from './models/customFields.types'

export const translateWebMessages = (name: string): string => mainTranslate(`frm_web_messages-${name}`)

export class CustomFieldsService {
  constructor(private provider: CustomFieldsProvider) {}

  public async get(
    groupId: CustomFieldsGroup,
    attributes: CustomFieldsAttributes = {},
  ): Promise<Result<CustomFieldsServerData>> {
    try {
      const { data } = await this.provider.get(groupId, attributes)
      return success(data)
    } catch (error) {
      return failure(CustomFieldsServiceErrorCode.GENERAL)
    }
  }

  public async custEEItems(action: CustEEItemsActions, params: Partial<CustEEItemParams>) {
    try {
      const { data } = await this.provider.custEEItems(action, params)
      return success(data)
    } catch (error) {
      if (error.response && error?.response?.status?.toString()[0] !== '2') {
        return failure(Number(error?.response), {
          message: `${error?.response?.status} ${error?.response?.statusText}`,
        })
      } else {
        return failure(Number(error.Code), {
          message: translateWebMessages(error.Message || error.Text),
        })
      }
    }
  }
}
